var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.clickedOutside),expression:"clickedOutside"}],ref:"contextMenu",staticClass:"contextMenu",class:[{ '_hidden': !_vm.visible }],style:({
    left: _vm.positionX + 'px',
    top: _vm.positionY + 'px'
  })},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }